import React from "react";
import { BellIcon } from "../Icons";
import { useKnockFeed } from "../KnockFeedProvider";
import { UnseenBadge } from "../UnseenBadge";
export var NotificationIconButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    onClick,
    badgeCountType
  } = _ref;
  var {
    colorMode
  } = useKnockFeed();
  return /*#__PURE__*/React.createElement("button", {
    className: "rnf-notification-icon-button rnf-notification-icon-button--".concat(colorMode),
    ref: ref,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(BellIcon, null), /*#__PURE__*/React.createElement(UnseenBadge, {
    badgeCountType: badgeCountType
  }));
});
//# sourceMappingURL=NotificationIconButton.js.map